import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { startOfMonth, endOfMonth } from "date-fns";
import { Table } from "./Table";
import { Filter, IFilter } from "./Filter";
import useToggle from "../../hooks/useToggle";

export interface IOpenForm {
    open: boolean,
    singleData: any
}

export const CustomerReport = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false })
    };

    const now = new Date();

    const [filter, setFilter] = useState<IFilter>({
        fromDate: startOfMonth(now),
        toDate: new Date()
    });
    return (
        <>
            <Filter filter={filter} setFilter={setFilter} loading={false} header="Filter" hasPermission={hasPermission} />
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData} filter={filter} />
            <Toast ref={toast} />
        </>
    );
}
